(function () {
  'use strict';

  window.FrontoKingCatalog = {
    categories: [
      { id: 'crushed-products', label: 'Crushed Products', copy: 'Dark Crush in bottle and pouch formats.' },
      { id: 'cigarillos', label: 'Cigarillos', copy: 'Single and 5 PK Fronto King cigarillos.' },
      { id: 'hand-rolled-cigars', label: 'Hand-Rolled Cigars', copy: 'Natural and flavor-infused hand-rolled cigars.' },
      { id: 'natural-whole-leaf', label: 'Natural Whole Leaf', copy: 'Natural, Wizzla, smooth, and mini whole-leaf formats.' },
      { id: 'wraps', label: 'Wraps', copy: 'Eight hand-cut wraps and Dark Cuts two-wrap packs.' }
    ],
    products: [
      {
        id: 'FKDC12',
        slug: 'dark-crush-12g-bottle',
        name: 'Dark Crush 12G Bottle',
        category: 'crushed-products',
        format: '24-count display / 288-count master case',
        description: 'A premium pipe tobacco blend with strong flavor, a bold hit, and a crispy finish, packed in a 12-gram bottle.',
        displayImage: 'fk-product-dark-crush-12g-bottle-display.jpg',
        frontImage: 'fk-product-dark-crush-12g-bottle-front.jpg',
        featured: true
      },
      {
        id: 'FKDC6P',
        slug: 'dark-crush-6g-pouch',
        name: 'Dark Crush 6G Pouch',
        category: 'crushed-products',
        format: '12-count display / 288-count master case',
        description: 'A premium pipe tobacco blend with strong flavor, a bold hit, and a crispy finish, packed in a compact 6-gram pouch.',
        displayImage: 'fk-product-dark-crush-6g-pouch-display.jpg',
        frontImage: 'fk-product-dark-crush-6g-pouch-front.jpg'
      },
      {
        id: 'FKDC6B',
        slug: 'dark-crush-6g-bottle',
        name: 'Dark Crush 6G Bottle',
        category: 'crushed-products',
        format: '24-count display / 288-count master case',
        description: 'A premium pipe tobacco blend with strong flavor, a bold hit, and a crispy finish, packed in a compact 6-gram bottle.',
        displayImage: 'fk-product-dark-crush-6g-bottle-display.jpg',
        frontImage: 'fk-product-dark-crush-6g-bottle-front.jpg'
      },
      {
        id: 'FK5PS',
        slug: '5-sweet-cigarillos',
        name: '5 PK Sweet Cigarillos',
        category: 'cigarillos',
        format: '12-count display / 144-count master case',
        description: 'Five natural-leaf cigarillos infused with food-grade flavoring for a mellow, sweet aroma and a smooth tobacco profile.',
        displayImage: 'fk-product-5-sweet-cigarillos-display.jpg',
        frontImage: 'fk-product-5-sweet-cigarillos-front.jpg',
        featured: true
      },
      {
        id: 'FK5PN',
        slug: '5-natural-cigarillos',
        name: '5 PK Natural Cigarillos',
        category: 'cigarillos',
        format: '12-count display / 144-count master case',
        description: 'Five natural-leaf cigarillos with a clean, smooth tobacco profile and classic Fronto King character.',
        displayImage: 'fk-product-5-natural-cigarillos-display.jpg',
        frontImage: 'fk-product-5-natural-cigarillos-front.jpg'
      },
      {
        id: 'FK5PR',
        slug: '5-rum-cream-cigarillos',
        name: '5 PK Rum Cream Cigarillos',
        category: 'cigarillos',
        format: '12-count display / 144-count master case',
        description: 'Five natural-leaf cigarillos infused with food-grade rum cream flavoring for a smooth, aromatic tobacco profile.',
        displayImage: 'fk-product-5-rum-cream-cigarillos-display.jpg',
        frontImage: 'fk-product-5-rum-cream-cigarillos-front.jpg'
      },
      {
        id: 'FKSN',
        slug: 'single-natural-cigarillo',
        name: 'Single Natural Cigarillo',
        category: 'cigarillos',
        format: '24-count display / 576-count master case',
        description: 'A single natural-leaf cigarillo with a smooth, balanced tobacco profile and classic Fronto King character.',
        displayImage: 'fk-product-single-natural-cigarillo-display.jpg',
        frontImage: 'fk-product-single-natural-cigarillo-front.jpg',
        featured: true
      },
      {
        id: 'FK5PB',
        slug: '5-banana-cigarillos',
        name: '5 PK Banana Cigarillos',
        category: 'cigarillos',
        format: '12-count display / 144-count master case',
        description: 'Five natural-leaf cigarillos infused with food-grade banana flavoring for a mellow, aromatic tobacco profile.',
        displayImage: 'fk-product-5-banana-cigarillos-display.jpg',
        frontImage: 'fk-product-5-banana-cigarillos-front.jpg'
      },
      {
        id: 'FKWZC',
        slug: 'wizzla-cigar',
        name: 'Wizzla Cigar',
        category: 'hand-rolled-cigars',
        format: '12-count display / 144-count master case',
        description: 'A large hand-rolled premium cigar made with naturally fermented Wizzla leaf hand-selected for a stronger, fuller tobacco character.',
        displayImage: 'fk-product-wizzla-cigar-display.jpg',
        frontImage: 'fk-product-wizzla-cigar-front.jpg',
        featured: true
      },
      {
        id: 'FKSC',
        slug: 'single-cigar',
        name: 'Single Cigar',
        category: 'hand-rolled-cigars',
        format: '12-count display / 144-count master case',
        description: 'A large hand-rolled premium cigar made with naturally fermented Fronto leaf for a smooth, balanced tobacco profile.',
        displayImage: 'fk-product-single-cigar-display.jpg',
        frontImage: 'fk-product-single-cigar-front.jpg'
      },
      {
        id: 'FKDC',
        slug: 'double-cigar',
        name: 'Double Cigar',
        category: 'hand-rolled-cigars',
        format: '12-count display / 144-count master case',
        description: 'Two large hand-rolled premium cigars made with naturally fermented Fronto leaf for a smooth, balanced tobacco profile.',
        displayImage: 'fk-product-double-cigar-display.jpg',
        frontImage: 'fk-product-double-cigar-front.jpg'
      },
      {
        id: 'FKCH',
        slug: 'chocolate-cigar',
        name: 'Chocolate Cigar',
        category: 'hand-rolled-cigars',
        format: '12-count display / 144-count master case',
        description: 'A large hand-rolled premium cigar made with natural tobacco leaf and infused with food-grade chocolate flavoring for a rich, aromatic profile.',
        displayImage: 'fk-product-chocolate-cigar-display.jpg',
        frontImage: 'fk-product-chocolate-cigar-front.jpg',
        featured: true
      },
      {
        id: 'FKSW',
        slug: 'sweet-cigar',
        name: 'Sweet Cigar',
        category: 'hand-rolled-cigars',
        format: '12-count display / 144-count master case',
        description: 'A large hand-rolled premium cigar made with natural tobacco leaf and infused with food-grade flavoring for a mellow, sweet aroma.',
        displayImage: 'fk-product-sweet-cigar-display.jpg',
        frontImage: 'fk-product-sweet-cigar-front.jpg'
      },
      {
        id: 'FKST',
        slug: 'strawberry-cigar',
        name: 'Strawberry Cigar',
        category: 'hand-rolled-cigars',
        format: '12-count display / 144-count master case',
        description: 'A large hand-rolled premium cigar made with natural tobacco leaf and infused with food-grade strawberry flavoring for a bright, aromatic profile.',
        displayImage: 'fk-product-strawberry-cigar-display.jpg',
        frontImage: 'fk-product-strawberry-cigar-front.jpg'
      },
      {
        id: 'FKGR',
        slug: 'grape-cigar',
        name: 'Grape Cigar',
        category: 'hand-rolled-cigars',
        format: '12-count display / 144-count master case',
        description: 'A large hand-rolled premium cigar made with natural tobacco leaf and infused with food-grade grape flavoring for a rich, aromatic profile.',
        displayImage: 'fk-product-grape-cigar-display.jpg',
        frontImage: 'fk-product-grape-cigar-front.jpg'
      },
      {
        id: 'FKHB',
        slug: 'honey-berry-cigar',
        name: 'Honey Berry Cigar',
        category: 'hand-rolled-cigars',
        format: '12-count display / 144-count master case',
        description: 'A large hand-rolled premium cigar made with natural tobacco leaf and infused with food-grade honey berry flavoring for a smooth, aromatic profile.',
        displayImage: 'fk-product-honey-berry-cigar-display.jpg',
        frontImage: 'fk-product-honey-berry-cigar-front.jpg'
      },
      {
        id: 'FKVA',
        slug: 'vanilla-cigar',
        name: 'Vanilla Cigar',
        category: 'hand-rolled-cigars',
        format: '12-count display / 144-count master case',
        description: 'A large hand-rolled premium cigar made with natural tobacco leaf and infused with food-grade vanilla flavoring for a mellow, aromatic profile.',
        displayImage: 'fk-product-vanilla-cigar-display.jpg',
        frontImage: 'fk-product-vanilla-cigar-front.jpg'
      },
      {
        id: 'FKBA',
        slug: 'banana-cigar',
        name: 'Banana Cigar',
        category: 'hand-rolled-cigars',
        format: '12-count display / 144-count master case',
        description: 'A large hand-rolled premium cigar made with natural tobacco leaf and infused with food-grade banana flavoring for a mellow, aromatic profile.',
        displayImage: 'fk-product-banana-cigar-display.jpg',
        frontImage: 'fk-product-banana-cigar-front.jpg'
      },
      {
        id: 'FKMA',
        slug: 'mango-cigar',
        name: 'Mango Cigar',
        category: 'hand-rolled-cigars',
        format: '12-count display / 144-count master case',
        description: 'A large hand-rolled premium cigar made with natural tobacco leaf and infused with food-grade mango flavoring for a bright, aromatic profile.',
        displayImage: 'fk-product-mango-cigar-display.jpg',
        frontImage: 'fk-product-mango-cigar-front.jpg'
      },
      {
        id: 'FKHN',
        slug: 'honey-cigar',
        name: 'Honey Cigar',
        category: 'hand-rolled-cigars',
        format: '12-count display / 144-count master case',
        description: 'A large hand-rolled premium cigar made with natural tobacco leaf and infused with food-grade honey flavoring for a smooth, lightly sweet aroma.',
        displayImage: 'fk-product-honey-cigar-display.jpg',
        frontImage: 'fk-product-honey-cigar-front.jpg'
      },
      {
        id: 'FKMC',
        slug: 'wizzla-mini-cigar',
        name: 'Wizzla Mini Cigar',
        category: 'hand-rolled-cigars',
        format: '12-count display / 144-count master case',
        description: 'A compact hand-rolled premium cigar made with stronger natural Wizzla leaf for a bold tobacco profile in a smaller format.',
        displayImage: 'fk-product-wizzla-mini-cigar-display.jpg',
        frontImage: 'fk-product-wizzla-mini-cigar-front.jpg'
      },
      {
        id: 'FKCG',
        slug: 'cognac-cigar',
        name: 'Cognac Cigar',
        category: 'hand-rolled-cigars',
        format: '12-count display / 144-count master case',
        description: 'A large hand-rolled premium cigar made with natural tobacco leaf and infused with food-grade cognac flavoring for a deep, aromatic profile.',
        displayImage: 'fk-product-cognac-cigar-display.jpg',
        frontImage: 'fk-product-cognac-cigar-front.jpg'
      },
      {
        id: 'FKPA',
        slug: 'pineapple-cigar',
        name: 'Pineapple Cigar',
        category: 'hand-rolled-cigars',
        format: '12-count display / 144-count master case',
        description: 'A large hand-rolled premium cigar made with natural tobacco leaf and infused with food-grade pineapple flavoring for a bright, aromatic profile.',
        displayImage: 'fk-product-pineapple-cigar-display.jpg',
        frontImage: 'fk-product-pineapple-cigar-front.jpg'
      },
      {
        id: 'FKMT',
        slug: 'icy-mint-cigar',
        name: 'Icy Mint Cigar',
        category: 'hand-rolled-cigars',
        format: '12-count display / 144-count master case',
        description: 'A large hand-rolled premium cigar made with natural tobacco leaf and infused with menthol for a cool pull and a crisp, refreshing finish.',
        displayImage: 'fk-product-icy-mint-cigar-display.jpg',
        frontImage: 'fk-product-icy-mint-cigar-front.jpg'
      },
      {
        id: 'FKWN',
        slug: 'natural-whole-leaf',
        name: 'Natural Whole Leaf',
        category: 'natural-whole-leaf',
        format: '12-count display / 144-count master case',
        description: 'A top-grade whole natural tobacco leaf, naturally fermented for a balanced, authentic tobacco flavor and classic Fronto character.',
        displayImage: 'fk-product-natural-whole-leaf-display.jpg',
        frontImage: 'fk-product-natural-whole-leaf-front.jpg',
        featured: true
      },
      {
        id: 'FKMF',
        slug: 'mini-leaf',
        name: 'Natural Mini Leaf',
        category: 'natural-whole-leaf',
        format: '12-count display / 144-count master case',
        description: 'A smaller-format version of Natural Whole Leaf, selected from top-grade natural tobacco for the same smooth, balanced Fronto character.',
        displayImage: 'fk-product-mini-leaf-display.jpg',
        frontImage: 'fk-product-mini-leaf-front.jpg',
        featured: true
      },
      {
        id: 'FKWS',
        slug: 'smooth-whole-leaf',
        name: 'Smooth Whole Leaf',
        category: 'natural-whole-leaf',
        format: '12-count display / 144-count master case',
        description: 'A thinner whole natural tobacco leaf selected for a gentler, smoother profile while keeping authentic Fronto leaf character.',
        displayImage: 'fk-product-smooth-whole-leaf-display.jpg',
        frontImage: 'fk-product-smooth-whole-leaf-front.jpg'
      },
      {
        id: 'FKWZL',
        slug: 'wizzla-whole-leaf',
        name: 'Wizzla Whole Leaf',
        category: 'natural-whole-leaf',
        format: '12-count display / 144-count master case',
        description: 'A naturally fermented whole tobacco leaf hand-selected for a stronger, fuller tobacco character and signature Wizzla profile.',
        displayImage: 'fk-product-wizzla-whole-leaf-display.jpg',
        frontImage: 'fk-product-wizzla-whole-leaf-front.jpg'
      },
      {
        id: 'FK8WN',
        slug: '8-natural-hand-cut-wraps',
        name: '8 Natural Hand-Cut Wraps',
        category: 'wraps',
        format: '12-count display / 144-count master case',
        description: 'Eight hand-cut wraps made from Fronto King Natural Whole Leaf for a consistent natural-leaf format with classic Fronto character.',
        displayImage: 'fk-product-8-hand-cut-wraps-display.jpg',
        frontImage: 'fk-product-8-hand-cut-wraps-front.jpg',
        featured: true
      },
      {
        id: 'FK2DC',
        slug: 'dark-cuts-2-natural-wraps',
        name: 'Dark Cuts - 2 Natural Wraps',
        category: 'wraps',
        format: '24-count display / 288-count master case',
        description: 'Two hand-selected dark cuts from whole natural tobacco leaf, chosen for a stronger, richer tobacco profile.',
        displayImage: 'fk-product-dark-cuts-2-wraps-display.jpg',
        frontImage: 'fk-product-dark-cuts-2-wraps-front.jpg'
      }
    ]
  };

  window.FrontoKingMerch = [
    {
      id: 'FKMERCHHOODIE',
      name: 'Fronto King Signature Hoodie',
      category: 'Merch',
      format: 'Black-and-gold Fronto King hoodie for events and everyday wear',
      displayImage: 'frontoking_signature_hoodie_square.jpg',
      rewardPoints: 300,
      orderNote: 'Black-and-gold Fronto King signature hoodie'
    },
    {
      id: 'FKMERCHSHIRT',
      name: 'Fronto King Dark Crush T-Shirt',
      category: 'Merch',
      format: 'Dark Crush graphics on a black Fronto King tee',
      displayImage: 'frontoking_dark_crush_shirt_lifestyle_4x5.jpg',
      rewardPoints: 150,
      orderNote: 'Official Fronto King Dark Crush apparel'
    },
    {
      id: 'FKMERCHTRAY',
      name: 'Fronto King Rolling Tray',
      category: 'Merch',
      format: 'Metal Fronto King rolling tray finished in black and gold',
      displayImage: 'frontoking_rolling_tray_white_4x5.jpg',
      rewardPoints: 100,
      orderNote: 'Official Fronto King rolling tray'
    },
    {
      id: 'FKMERCHGRINDER',
      name: 'Fronto King Grinder',
      category: 'Merch',
      format: 'Compact metal Fronto King grinder in black and gold',
      displayImage: 'frontoking_grinder_white_4x5.jpg',
      rewardPoints: 120,
      orderNote: 'Official Fronto King grinder'
    },
    {
      id: 'FKMERCHBAG',
      name: 'Fronto King Drawstring Bag',
      category: 'Merch',
      format: 'Lightweight Fronto King drawstring bag for daily carry',
      displayImage: 'frontoking_drawstring_bag_lifestyle_4x5.jpg',
      rewardPoints: 100,
      orderNote: 'Official Fronto King drawstring bag'
    }
  ];

  window.FrontoKingInstagram = [
    { image: 'fk-instagram-01-dragger.jpg', label: 'Dragger music reel', type: 'reel', url: 'https://www.instagram.com/frontokingglobal/reel/C6wAUPsgCl1/' },
    { image: 'fk-instagram-02-gold-rush.jpg', label: 'Gold Rush Dark Crush reel', type: 'reel', url: 'https://www.instagram.com/frontokingglobal/reel/DSW6L-iDiEf/' },
    { image: 'fk-instagram-03-culture.jpg', label: 'Fronto King culture reel', type: 'reel', url: 'https://www.instagram.com/frontokingglobal/reel/C74XcnMAHty/' },
    { image: 'fk-instagram-04-chocolate.jpg', label: 'Chocolate cigar post', type: 'post', url: 'https://www.instagram.com/frontokingglobal/p/DYEk91CjLEZ/' },
    { image: 'fk-instagram-05-dark-crush.jpg', label: 'Dark Crush culture reel', type: 'reel', url: 'https://www.instagram.com/frontokingglobal/reel/DYCtiOAuqYX/' },
    { image: 'fk-instagram-06-cognac.jpg', label: 'Cognac cigar post', type: 'post', url: 'https://www.instagram.com/frontokingglobal/p/DX9qcV2u6Kb/' },
    { image: 'fk-instagram-07-banana.jpg', label: 'Banana cigar post', type: 'post', url: 'https://www.instagram.com/frontokingglobal/p/DX62OikDh19/' },
    { image: 'fk-instagram-08-product.jpg', label: 'Fronto King product post', type: 'post', url: 'https://www.instagram.com/frontokingglobal/p/DX1f3f3Drm8/' },
    { image: 'fk-instagram-09-product.jpg', label: 'Fronto King product and culture post', type: 'post', url: 'https://www.instagram.com/frontokingglobal/p/DXzQLkLDgKc/' }
  ];
})();
